module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/benefits/dish-276b598ac74760225428a5f95c6663be.svg";